export default "__VITE_ASSET__D_flbH4X__"